/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Serialize an object of key/value pairs to URL query parameters
 */
export default function serializeUrlParams(paramsObj: Record<string, any>, { shouldOmitInvalidParams = false } = {}) {
  return Object.entries(paramsObj)
    .map(([key, val]) => {
      if (shouldOmitInvalidParams && !['string', 'boolean', 'number'].includes(typeof val)) {
        // keep null values (`?param=null`)
        if (val !== null) {
          return ''
        }
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
    })
    .filter(Boolean)
    .join('&')
}
